import { render, staticRenderFns } from "./newsInformation.vue?vue&type=template&id=54bc388e&scoped=true&"
import script from "./newsInformation.vue?vue&type=script&lang=js&"
export * from "./newsInformation.vue?vue&type=script&lang=js&"
import style0 from "./newsInformation.vue?vue&type=style&index=0&id=54bc388e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bc388e",
  null
  
)

export default component.exports